module.exports = __webpack_public_path__ + "static/media/cmdinit-min.97d93c83.png";